(function () {
  if (window.__pcpCartGroupInit) return;
  window.__pcpCartGroupInit = true;

  const PCP_CART_EDIT_RESTORE_KEY = 'pcp-cart-edit-restore';
  const PCP_CART_EDIT_KEYS_KEY = 'pcp-cart-edit-keys';
  const GROUP_PROP = '_Customizer Group';
  const RETURN_URL_PROP = '_Customizer Return URL';
  const DEFAULT_RETURN_URL = '/collections/custom-jewelry-builder-bracelets';

  function getCartRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';
  }

  function decodeHtmlEntities(value) {
    if (value == null) return '';
    return String(value)
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  }

  function getLineItemProp(item, key) {
    if (!item || !item.properties) return '';
    const value = item.properties[key];
    return value != null ? String(value).trim() : '';
  }

  function parseCharmPlacementFromProperties(properties) {
    const result = {};
    if (!properties) return result;

    const positionRaw = getLineItemProp({ properties: properties }, '_Position');
    if (positionRaw) {
      try {
        const parsed = JSON.parse(positionRaw);
        if (
          parsed &&
          typeof parsed.x === 'number' &&
          !Number.isNaN(parsed.x) &&
          typeof parsed.y === 'number' &&
          !Number.isNaN(parsed.y)
        ) {
          result.position = {
            x: parsed.x,
            y: parsed.y,
          };
          if (parsed.relativeTo === 'chain') {
            result.position.relativeTo = 'chain';
          }
        }
      } catch (e) {}
    }

    const rotationRaw = getLineItemProp({ properties: properties }, '_Rotation');
    if (rotationRaw !== '') {
      const rotation = Number(rotationRaw);
      if (!Number.isNaN(rotation)) {
        result.rotation = rotation;
      }
    }

    return result;
  }

  function formatCartLineItemPrice(item) {
    const displayPrice = getLineItemProp(item, '_Price Display');
    if (displayPrice) return displayPrice;

    const rawPrice = item.final_price != null ? item.final_price : item.price;
    if (rawPrice == null || rawPrice === '') return '';

    const rawStr = String(rawPrice).trim();
    if (!/^\d+$/.test(rawStr)) return rawStr;

    const cents = Number(rawStr);
    if (Number.isNaN(cents)) return rawStr;

    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }

    return 'Rs.' + (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function lineItemToEditProduct(item) {
    const canvasImage = getLineItemProp(item, '_Canvas Image');
    const placement = parseCharmPlacementFromProperties(item.properties);
    return {
      type: getLineItemProp(item, '_Customizer Type') || 'other',
      productId: String(item.product_id),
      variantId: String(item.variant_id),
      variantTitle: decodeHtmlEntities(
        getLineItemProp(item, '_Variant Label') || item.variant_title || ''
      ),
      title: item.product_title || item.title || '',
      imageSrc:
        canvasImage ||
        item.image ||
        (item.featured_image && item.featured_image.url) ||
        '',
      hasPersonalizerImage: getLineItemProp(item, '_Has Personalizer Image') === 'true',
      price: formatCartLineItemPrice(item),
      id: getLineItemProp(item, '_Customizer Instance'),
      engravingText: getLineItemProp(item, 'Engraving'),
      engravingFont: getLineItemProp(item, 'Engraving Font'),
      position: placement.position,
      rotation: placement.rotation,
    };
  }

  function dispatchLoading(start) {
    document.documentElement.dispatchEvent(
      new CustomEvent(start ? 'theme:loading:start' : 'theme:loading:end', { bubbles: true })
    );
  }

  async function removeCartKeys(keys) {
    const updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    const response = await fetch(getCartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates: updates }),
    });

    if (!response.ok) {
      throw new Error('Failed to update cart');
    }
  }

  function isCartPage() {
    return (
      window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.pageType === 'cart'
    );
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );

    if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchShopifyCart === 'function') {
      window.Rebuy.Cart.fetchShopifyCart();
    }
  }

  async function handleRemove(removeButton) {
    const keysValue = removeButton.getAttribute('data-pcp-group-keys');
    if (!keysValue) return;

    const keys = keysValue
      .split(',')
      .map(function (key) {
        return key.trim();
      })
      .filter(Boolean);

    if (!keys.length) return;

    removeButton.setAttribute('aria-busy', 'true');
    dispatchLoading(true);

    try {
      await removeCartKeys(keys);
      if (isCartPage()) {
        window.location.reload();
        return;
      }
      refreshCart();
    } catch (error) {
      console.error('[Customizer Cart Group]', error);
    } finally {
      removeButton.removeAttribute('aria-busy');
      dispatchLoading(false);
    }
  }

  async function handleEdit(editButton) {
    const groupEl = editButton.closest('[data-pcp-group-id]');
    const groupId = groupEl ? groupEl.getAttribute('data-pcp-group-id') : '';
    const keysValue = editButton.getAttribute('data-pcp-group-keys');
    if (!groupId || !keysValue) return;

    const keys = keysValue
      .split(',')
      .map(function (key) {
        return key.trim();
      })
      .filter(Boolean);

    if (!keys.length) return;

    editButton.setAttribute('aria-busy', 'true');
    dispatchLoading(true);

    try {
      const cartResponse = await fetch(getCartRoot() + 'cart.js');
      if (!cartResponse.ok) {
        throw new Error('Failed to load cart');
      }

      const cart = await cartResponse.json();
      const groupItems = (cart.items || []).filter(function (item) {
        return getLineItemProp(item, GROUP_PROP) === groupId;
      });

      if (!groupItems.length) {
        throw new Error('Custom jewelry set not found in cart');
      }

      let returnUrl = editButton.getAttribute('data-pcp-group-return-url') || '';
      if (!returnUrl) {
        groupItems.some(function (item) {
          const candidate = getLineItemProp(item, RETURN_URL_PROP);
          if (candidate) {
            returnUrl = candidate;
            return true;
          }
          return false;
        });
      }

      if (!returnUrl) {
        returnUrl = window.__pcpCustomizerReturnUrl || DEFAULT_RETURN_URL;
      }

      sessionStorage.removeItem('pcp-cart-edit');
      sessionStorage.setItem('pcp-skip-customizer-timeline', '1');
      sessionStorage.setItem(
        PCP_CART_EDIT_RESTORE_KEY,
        JSON.stringify({
          groupId: groupId,
          returnUrl: returnUrl,
          products: groupItems.map(lineItemToEditProduct),
          selections: (function () {
            let savedSelections = null;
            groupItems.some(function (item) {
              const raw = getLineItemProp(item, '_Customizer Selections');
              if (!raw) return false;
              try {
                savedSelections = JSON.parse(raw);
              } catch (e) {
                savedSelections = null;
              }
              return !!savedSelections;
            });
            return savedSelections;
          })(),
        })
      );
      sessionStorage.setItem(PCP_CART_EDIT_KEYS_KEY, JSON.stringify(keys));

      const currentUrl = window.location.pathname + window.location.search;
      const normalizedReturnUrl = returnUrl.replace(/\/$/, '');
      const normalizedCurrentUrl = currentUrl.replace(/\/$/, '');
      if (normalizedReturnUrl === normalizedCurrentUrl) {
        window.location.reload();
      } else {
        window.location.href = returnUrl;
      }
    } catch (error) {
      console.error('[Customizer Cart Group]', error);
      sessionStorage.removeItem(PCP_CART_EDIT_RESTORE_KEY);
      sessionStorage.removeItem(PCP_CART_EDIT_KEYS_KEY);
      sessionStorage.removeItem('pcp-cart-edit');
      dispatchLoading(false);
      editButton.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (event) {
    const editButton = event.target.closest('[data-pcp-group-edit]');
    if (editButton) {
      event.preventDefault();
      handleEdit(editButton);
      return;
    }

    const removeButton = event.target.closest('[data-pcp-group-remove]');
    if (!removeButton) return;

    event.preventDefault();
    handleRemove(removeButton);
  });
})();
